import type { IPageAnalyticMapping } from '../../modules/analytic/types';

import { usePageAnalyticDetailContext } from '../../contexts/PageAnalyticDetailProvider';
import { PALineChartGroup } from '../../modules/analytic';
import { useAnalyticData } from '~/core/gemxql/hooks';
import { EMetricKey } from '~/types/metric';
import { Grid } from '@shopify/polaris';
import { useMemo } from 'react';

const ANALYTICS_DATA_FIRST: IPageAnalyticMapping[] = [
  { key: EMetricKey.CART_ADDITION, title: 'Sessions with cart additions' },
  { key: EMetricKey.REACHED_CHECKOUT, title: 'Sessions that reached checkout' },
  { key: EMetricKey.COMPLETE_CHECKOUT, title: 'Sessions that completed checkout' },
];
const ANALYTICS_DATA_SECOND: IPageAnalyticMapping[] = [
  { key: EMetricKey.CONVERSION_RATE, title: 'Conversion Rate' },
  { key: EMetricKey.AOV, title: 'AOV' },
  { key: EMetricKey.REVENUE, title: 'Revenue' },
];

export const PageAnalyticGridOverview = () => {
  const { totalsRow, comparisonTotalsRow, columnTypes, isLoading } = usePageAnalyticDetailContext();
  const { computeMetric } = useAnalyticData();

  const firstGroupData = useMemo(() => {
    return ANALYTICS_DATA_FIRST.map(({ key, title }) => ({
      key,
      title,
      control: computeMetric({
        metric: totalsRow,
        previousMetric: comparisonTotalsRow,
        metricKey: key,
        formatter: columnTypes?.[key],
      }),
    }));
  }, [totalsRow, comparisonTotalsRow, columnTypes, computeMetric]);

  const secondGroupData = useMemo(() => {
    return ANALYTICS_DATA_SECOND.map(({ key, title }) => ({
      key,
      title,
      control: computeMetric({
        metric: totalsRow,
        previousMetric: comparisonTotalsRow,
        metricKey: key,
        formatter: columnTypes?.[key],
      }),
    }));
  }, [totalsRow, comparisonTotalsRow, columnTypes, computeMetric]);

  return (
    <Grid gap={{ xs: '200' }}>
      <Grid.Cell
        columnSpan={{
          xs: 6,
          lg: 6,
        }}
      >
        <PALineChartGroup
          defaultActiveTab={EMetricKey.CART_ADDITION}
          analyticsData={firstGroupData}
          isLoading={isLoading}
        />
      </Grid.Cell>
      <Grid.Cell
        columnSpan={{
          xs: 6,
          lg: 6,
        }}
      >
        <PALineChartGroup
          defaultActiveTab={EMetricKey.CONVERSION_RATE}
          analyticsData={secondGroupData}
          isLoading={isLoading}
        />
      </Grid.Cell>
    </Grid>
  );
};
